import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import { State } from './States.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/states`;

export async function listStates(): Promise<PageResult<State>> {
  const result = (await api.get(`${CONTROLLER_URL}`, null)) as unknown;

  return result as PageResult<State>;
}
